// extracted by mini-css-extract-plugin
export default {"card":"CategoryCard_card__dA8MM","content":"CategoryCard_content__JJmWA"};